export default __webpack_public_path__ + "static/media/08AW2AUG66.4cebce1b.jpg";